export default __webpack_public_path__ + "static/media/gas.1535386a.svg";